import React, { useState, useEffect } from 'react';
import PermissionGuard from '../../../common/PermissionGuard';
import { useNavigate } from 'react-router-dom';
import { usePermissions } from '../../../../contexts/PermissionsContext';
import { toast } from 'react-toastify';
import { coursesApi } from '../../../../services/api/courses.api';
import { LoadingSpinner } from '../../../common/LoadingSpinner';
import { BASE_URL } from '../../../../config/axios';

const CourseContent = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { hasPermission } = usePermissions();

  // جلب الدورات من API
  useEffect(() => {
    // مسح كاش الصلاحيات للتأكد من تحديثها
    localStorage.removeItem('permissionsCache');
    fetchCourses();
  }, []);

  const fetchCourses = async () => {
    setLoading(true);
    try {
      const response = await coursesApi.getAll();
      // التحقق من شكل البيانات وتحويلها إلى مصفوفة إذا لزم الأمر
      // استجابة API
      
      let coursesData = [];
      if (response && response.data) {
        coursesData = Array.isArray(response.data) ? response.data : [response.data];
      } else if (Array.isArray(response)) {
        coursesData = response;
      } else if (response) {
        coursesData = [response];
      }
      
      setCourses(coursesData);
    } catch (error) {
      // خطأ في جلب الدورات
      toast.error('حدث خطأ أثناء جلب الدورات');
    } finally {
      setLoading(false);
    }
  };

  const handleEditContent = (courseId) => {
    // توجيه المستخدم إلى صفحة إدارة محتوى الدورة
    navigate(`/admin/dashboard/courses/content/${courseId}/manage`);
  };

  if (loading) {
    return (
      <div className="p-6">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg">
          <div className="flex items-center justify-center min-h-[400px]">
            <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-indigo-500"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg">
        <div className="border-b border-gray-200 dark:border-gray-700">
          <h1 className="text-xl font-semibold text-gray-900 dark:text-gray-100 text-center py-4">
            محتوى الدورات
          </h1>
        </div>
        
        <div className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {courses.length === 0 ? (
              <div className="col-span-3 text-center py-10 text-gray-500 dark:text-gray-400">
                لا توجد دورات متاحة حالياً
              </div>
            ) : (
              courses.map(course => (
                <div key={course.id} className="bg-white dark:bg-gray-700 rounded-lg shadow overflow-hidden">
                  {/* صورة الدورة */}
                  <div className="relative h-48 w-full">
                    <img
                      src={course.cover_image ? `${BASE_URL}/storage/${course.cover_image}` : 'https://placehold.co/600x400/png'}
                      alt={course.name}
                      className="w-full h-full object-cover"
                    />
                    {course.course_type === 'paid' && (
                      <div className="absolute top-4 right-4 bg-indigo-600 text-white px-3 py-1 rounded-full text-sm">
                        {parseInt(course.price)} <span style={{ fontFamily: 'saudi_riyal' }}>&#xE900;</span>
                      </div>
                    )}
                  </div>

                  {/* معلومات الدورة */}
                  <div className="p-4">
                    <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                      {course.name}
                    </h3>
                    
                    <div className="space-y-2 text-sm text-gray-600 dark:text-gray-300">
                      <div className="flex justify-between">
                        <span>المدرب:</span>
                        <span>{course.instructors && course.instructors.length > 0 ? course.instructors[0].name : 'لا يوجد'}</span>
                      </div>
                      <div className="flex justify-between">
                        <span>التصنيف:</span>
                        <span>{course.category ? course.category.name : 'لا يوجد'}</span>
                      </div>
                      <div className="flex justify-between">
                        <span>المدة:</span>
                        <span>{course.duration || 'لم تحدد'}</span>
                      </div>
                      <div className="flex justify-between">
                        <span>الملفات:</span>
                        <span>{course.lessons_count || 0}</span>
                      </div>
                    </div>

                    {/* أزرار التحكم */}
                    {hasPermission('create_course_content') && (
                      <div className="mt-4 flex justify-center">
                        <button
                          onClick={() => handleEditContent(course.id)}
                          className="px-4 py-2 bg-indigo-600 text-white rounded-md text-sm font-medium hover:bg-indigo-700 transition-colors duration-200 w-full"
                        >
                          إدارة محتوى الدورة
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseContent;
